/* eslint-disable no-unused-vars */
import React from 'react';
import {isMobile} from 'react-device-detect';
import {useTranslation} from 'react-i18next';
import {BrowserRouter as Router} from 'react-router-dom';
import {DesktopRouting} from '../../routes/browser/desktop-routing';
import {MobileRouting} from '../../routes/mobile/mobile-routing';
import {AlertsFilterService} from '../../services/alerts-filters/alerts-filters.service';
import {DataService} from '../../services/data-v2/data.service';
import {HeaderService} from '../../services/header/header.service';
import {MapService} from '../../services/map-v2/map.service';
import {SidebarService} from '../../services/sidebar/sidebar.service';
import {SpinnerService} from '../../services/spinner/spinner.service';
import {ThemeService} from '../../services/theme/themeService';
import {TranslateService} from '../../services/translation/translation.service';
import {Map} from '../map/map.component';
import {Menu} from '../menu/menu';
import {SidebarComponent} from '../sidebar/sidebar.component';
import './app.scss';
import {AppHeader} from '../app-header/app-header.component';
import {AppFooter} from '../app-footer/app-footer.component';

function App() {
    const {t} = useTranslation();

    return (
        <Router>
            <SpinnerService>
                <DataService>
                    <TranslateService>
                        <ThemeService>
                            <SidebarService>
                                <AlertsFilterService>
                                    <HeaderService>
                                        <MapService>
                                            <div className='app-wrapper'>
                                                {!isMobile && <AppHeader />}

                                                {/* <Router>*/}
                                                <div className={isMobile ? 'app mobile' : 'app desktop map-container'}>
                                                    <Map/>
                                                    <SidebarComponent>
                                                        <Menu/>
                                                    </SidebarComponent>
                                                    {
                                                        isMobile ? <MobileRouting/> : <DesktopRouting/>
                                                    }
                                                </div>
                                                {/* </Router>*/}
                                                {!isMobile && <AppFooter />}

                                            </div>
                                        </MapService>

                                    </HeaderService>
                                </AlertsFilterService>
                            </SidebarService>
                        </ThemeService>
                    </TranslateService>
                </DataService>
            </SpinnerService>
        </Router>
    );
}

export default App;
